import { Controller } from "@hotwired/stimulus"

// Client-only branching before an SCA draft exists. These answers are call
// guidance, not persisted agreement facts. Successful outcomes hand off to
// server-side case resolution.
export default class extends Controller {
  static targets = ["screen", "script", "heading"]
  static values = { hasNetwork: Boolean }

  connect() {
    // Initial render only — must not steal focus from whatever the operator
    // was already doing (e.g. the page's own focus-on-load).
    this.show("rbp")
  }

  acceptRbp() {
    this.show("rbp_details", { focus: true })
  }

  declineRbp() {
    this.show(this.hasNetworkValue ? "network" : "cash", { focus: true })
  }

  acceptNetwork() {
    this.show("id_card", { focus: true })
  }

  declineNetwork() {
    this.show("cash", { focus: true })
  }

  show(key, { focus = false } = {}) {
    this.screenTargets.forEach((panel) => { panel.hidden = panel.dataset.flowKey !== key })
    this.scriptTargets.forEach((panel) => { panel.hidden = panel.dataset.flowKey !== key })
    if (focus) {
      this.headingTargets.find((heading) => heading.dataset.flowKey === key)?.focus()
    }
  }
}
